import React from 'react';
import { useDispatch } from 'react-redux';
import { Box, Checkbox, FormControlLabel, makeStyles, Typography } from '@material-ui/core';
import intl from 'react-intl-universal';
import { Field } from 'redux-form';
import { getPrivacyLink, getTosLink } from 'utils/guest-localeUtil';
import { acceptTOS } from 'reducers/guestFlowSlice';
import { LsKey, lsSet } from 'utils/localStorageUtils';

const TermsOfService = () => {
  const classes = userFieldStyles();
  const dispatch = useDispatch();

  const handleTosAcceptance = (isAccepted: boolean) => {
    // If the TOS policy ever changes, it may be useful to know when the user last accepted the terms
    const timeStamp = isAccepted ? Date.now().toString() : '';
    lsSet(LsKey.TosAccepted, timeStamp);
    dispatch(acceptTOS(timeStamp));
  };

  const tosLabel = () => {
    return (
      <Typography className={classes.tosLabel} data-testid="termsCondition" component="span">
        {intl.getHTML('tosAgreement', {
          privacyLink: getPrivacyLink(),
          termsLink: getTosLink()
        })}
      </Typography>
    );
  };

  return (
    <Box mt={1} width={'100%'}>
      <Field
        name="tosCheckbox"
        component={({ input, label, name }) => (
          <FormControlLabel
            control={
              <Checkbox
                name={name}
                checked={Boolean(input.value)}
                onChange={(e, checked) => {
                  input.onChange(e);
                  handleTosAcceptance(!input.value);
                }}
                color="primary"
              />
            }
            data-testid="tosCheckbox"
            label={label}
            onFocus={input.onFocus}
          />
        )}
        type="checkbox"
        label={tosLabel()}
      />
    </Box>
  );
};

const userFieldStyles = makeStyles(() => ({
  tosLabel: {
    fontSize: '0.75rem'
  }
}));

export default TermsOfService;
